// frontend/src/components/Search.js
import React from 'react';

const Search = ({searchTerm, handleSearchChange, handleSearch}) => {
    return (
        <div className="d-inline-flex justify-content-end w-100">
            <div className="d-inline-flex gap-1">
                <input type="text" value={searchTerm} onChange={handleSearchChange}
                       placeholder="kiabi, instance01, mysql ..."
                       className="form-control "/>
                <button type="submit" onClick={handleSearch}
                        className="btn btn-primary d-flex align-items-center justify-content-center me-3">
                    <i className="bi bi-search"></i>
                </button>
                <a
                    href={'https://grafana.observability.frequentiel.com/d/be63d58ssda0wd/versions?orgId=1'}
                    target={'_blank'}
                    className="btn btn-outline-danger  w-100 d-flex align-items-center justify-content-center gap-2 me-2">
                    Azure
                    <i className="bi bi-graph-up"></i>
                </a>

                <a
                    href={'https://grafana.hz.observability.frequentiel.com/d/be63d58ssda0wd/versions?orgId=1'}
                    target={'_blank'}
                    className="btn btn-outline-success w-100  d-flex align-items-center justify-content-center gap-2 me-2">
                    Hetzner
                    <i className="bi bi-graph-up"></i>
                </a>
                <a
                    href={'https://frequentiel.atlassian.net/jira/dashboards/11081'}
                    target={'_blank'}
                    className="btn btn-outline-dark w-100  d-flex align-items-center justify-content-center gap-2">
                    Release
                    <i className="bi bi-calendar-check"></i>
                </a>
            </div>
        </div>
    );
};

export default Search;
